import { render, staticRenderFns } from "./CardMarketing.vue?vue&type=template&id=30dc2124&scoped=true&"
import script from "./CardMarketing.vue?vue&type=script&lang=js&"
export * from "./CardMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dc2124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30dc2124')) {
      api.createRecord('30dc2124', component.options)
    } else {
      api.reload('30dc2124', component.options)
    }
    module.hot.accept("./CardMarketing.vue?vue&type=template&id=30dc2124&scoped=true&", function () {
      api.rerender('30dc2124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/CardMarketing.vue"
export default component.exports